const primary = `0,47,69
74,101,118
104,146,171
171,225,250
212,239,252`.split("\n");

const secondary = `22,110,149
53,163,155
93,137,60
158,178,59
241,193,43
239,129,44
230,94,63
230,28,67
177,63,128
113,38,110`.split("\n");

const secondary2 = `82,129,164
104,176,171
122,153,87
179,190,93
244,208,93
243,151,83
234,125,93
234,90,92
189,102,148
133,76,129`.split("\n");

const secondary3 = `122,152,181
142,192,189
150,172,122
194,204,132
246,218,134
246,175,120
239,154,125
238,131,123
202,136,169
115,112,152`.split("\n");

const secondary4 = `161,180,201
178,210,207
181,194,158
213,218,168
249,228,172
249,200,160
244,185,162
244,169,159
216,171,193
181,150,179`.split("\n");

const secondary5 = `204,212,224
214,229,228
214,220,201
232,234,208
251,240,210
252,225,203
249,218,208
249,210,202
233,210,221
212,196,212`.split("\n");

const tertiary = `0,47,69
66,85,53
215,137,44
249,157,51
244,118,64
168,72,55`.split("\n");

const tertiary2 = `44,73,94
94,108,81
223,159,83
251,175,93
246,143,96
182,102,83`.split("\n");

const tertiary3 = `84,104,124
126,135,112
231,178,119
253,194,129
249,169,129
196,132,113`.split("\n");

const tertiary4 = `129,143,159
238,200,158
254,213,167
254,213,167
252,196,165
213,167,151`.split("\n");

const tertiary5 = `182,189,200
200,204,194
246,224,200
255,232,207
254,224,206
230,205,195`.split("\n");

function rgb2hex(r, g, b) {
  r = r.toString(16);
  g = g.toString(16);
  b = b.toString(16);

  if (r.length == 1)
    r = "0" + r;
  if (g.length == 1)
    g = "0" + g;
  if (b.length == 1)
    b = "0" + b;

  return "#" + r + g + b;
}

function prep(text) {
  return text.map(x => x.split(',').map(y => parseInt(y)));
}

var prim = prep(primary);

var sec1 = prep(secondary)
var sec2 = prep(secondary2)
var sec3 = prep(secondary3)
var sec4 = prep(secondary4)
var sec5 = prep(secondary5)

var ter1 = prep(tertiary);
var ter2 = prep(tertiary2);
var ter3 = prep(tertiary3);
var ter4 = prep(tertiary4);
var ter5 = prep(tertiary5);

var groupedDiff = [];
var i = 0;
for (let i = 0; i < sec1.length; i++) {
  groupedDiff.push([sec1[i], sec2[i], sec3[i], sec4[i], sec5[i]])
}

var groupedDiffTer = [];
i = 0;
for (let i = 0; i < ter1.length; i++) {
  groupedDiffTer.push([ter1[i], ter2[i], ter3[i], ter4[i], ter5[i]])
}
var colorObj = {
  primary: {},
  secondary: {},
  tertiary: {}
};
i = 0;
prim.forEach(function(color) {
  i++;
  let r = color[0]
  let g = color[1]
  let b = color[2]
  // console.log(rgb2hex(r, g, b))
  var intensity = 100 - ((i - 1) * 20);
  colorObj.primary[intensity] = {
    r: r,
    g: g,
    b: b,
    hex: rgb2hex(r, g, b),
    rgba: 'rgba(' + r + ',' + g + ',' + b + ',1)'
  }
})
var names = ['blue', 'teal', 'green', 'lime', 'yellow', 'orange', 'ochre', 'magenta', 'violet', 'purple'];

let j = 0;
groupedDiff.forEach(function(fam) {
  i = 0;
  fam.forEach(function(color) {
    // console.log(color)
    if (!colorObj.secondary[names[j]]) colorObj.secondary[names[j]] = {};
    i++;
    let r = color[0]
    let g = color[1]
    let b = color[2]
    // console.log(rgb2hex(r, g, b))
    var intensity = 100 - ((i - 1) * 20);
    colorObj.secondary[names[j]][intensity] = {
      r: r,
      g: g,
      b: b,
      hex: rgb2hex(r, g, b),
      rgba: 'rgba(' + r + ',' + g + ',' + b + ',1)'
    }
  })
  j++;
})

j = 0;
let terNames = ['blue', 'green', 'yellow', 'gold', 'orange', 'red']
groupedDiffTer.forEach(function(fam) {
  i = 0;
  fam.forEach(function(color) {
    if (!colorObj.tertiary[terNames[j]]) colorObj.tertiary[terNames[j]] = {};
    i++;
    let r = color[0]
    let g = color[1]
    let b = color[2]
    // console.log(rgb2hex(r, g, b))
    var intensity = 100 - ((i - 1) * 20);
    colorObj.tertiary[terNames[j]][intensity] = {
      r: r,
      g: g,
      b: b,
      hex: rgb2hex(r, g, b),
      rgba: 'rgba(' + r + ',' + g + ',' + b + ',1)'
    }
  })
  j++;
})

// to generate SCSS variables after a change, use this:
// function generateSCSSVariables() {
//   for (let k of Object.keys(colorObj)) {
//     for (let j of Object.keys(colorObj[k])) {
//       var name = k + j;
//       var rgb = colorObj[k][j].rgba;
//       var hex = colorObj[k][j].hex
//       console.log('$' + name + ': ' + rgb+';');
//       console.log('$' + name + 'hex: ' + hex+';');
//     }
//   }
// }

// to generate an object, use this:
// console.log(JSON.stringify(colorObj,null,2))

module.exports = colorObj;